const findPdfForLot = (lot) => {
  return (
    lot?.documents_pdfs?.find(
      (doc) =>
        doc?.type === "plan_vente" &&
        doc?.document?.[0]?.url?.toLowerCase().includes(".pdf"),
    ) ||
    lot?.documents_pdfs?.find(
      (doc) =>
        doc?.type === "plan_etage" &&
        doc?.document?.[0]?.url?.toLowerCase().includes(".pdf"),
    ) ||
    lot?.documents_pdfs?.find(
      (doc) =>
        doc?.type?.toLowerCase().includes("plan") &&
        doc?.document?.[0]?.url?.toLowerCase().includes(".pdf"),
    ) ||
    lot?.documents_pdfs?.[0]
  );
};

export default findPdfForLot;
